export default __webpack_public_path__ + "static/media/port8.55de8e75.png";